import { EMOJI_SHORTCUTS } from "../lib/validators";

interface EmojiBarProps {
  onInsert: (emoji: string) => void;
}

export function EmojiBar({ onInsert }: EmojiBarProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {EMOJI_SHORTCUTS.map((emoji) => (
        <button
          key={emoji}
          type="button"
          onClick={() => onInsert(emoji)}
          className="h-9 w-9 rounded border border-line bg-white text-lg shadow-sm transition hover:border-brand hover:bg-brand/5"
          title={`Insert ${emoji}`}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
}
